"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowRight = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var ArrowRight = function () { return (react_1.default.createElement("path", { fill: "currentColor", d: "M2 11.5a.5.5 0 01.5-.5h16.17l-4.45-4.44a.5.5 0 010-.71l.71-.7a.5.5 0 01.71 0l6.14 6.13c.14.14.22.331.22.53v.38a.77.77 0 01-.22.53l-6.14 6.13a.5.5 0 01-.71 0l-.71-.71a.49.49 0 010-.7L18.67 13H2.5a.5.5 0 01-.5-.5v-1z" })); };
exports.ArrowRight = ArrowRight;
//# sourceMappingURL=arrow-right.js.map